import { render, staticRenderFns } from "./AppReleases.vue?vue&type=template&id=7f9d3158"
import script from "./AppReleases.vue?vue&type=script&lang=js"
export * from "./AppReleases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports